import { register } from "react-native-bundle-splitter";

export * from "./PropertyNavigator";
export * from "./useProperty";

export default register({ loader: () => import("./PropertyNavigator") });
